// extracted by mini-css-extract-plugin
export var deliveryRow = "_ln-a";
export var fixedHeight = "_ln-4";
export var freightLogo = "_ln-9";
export var fullWidth = "_ln-3";
export var priceColumn = "_ln-5";
export var radioSelected = "_ln-7";
export var radioUnselected = "_ln-6";
export var selectedOption = "_ln-2";
export var selectedOptionContainer = "_ln-1";
export var selection = "_ln-0";
export var tallSkeletonText = "_ln-8";